<template>
  <b-nav class="nav-toggled">
    <!-- <img class="Item" src="@/assets/PentagroIcon2.png" alt="Ícone Pentagro" /> -->
    <b-nav-item-dropdown no-caret :text="$t('monitoring')" class="toggled" left id="button-monitoring">
      
      <template v-for="screen in screenList">
        <DropDownItem 
          v-if="screen.route"
          :key=screen.screen 
          :image=image 
          :route="screen.route"
          :text=screen.permission 
          :altTxt=screen.tooltip 
          :title=screen.tooltip
        ></DropDownItem>
        <DropDownItemModal 
          v-if="screen.modal"
          :key=screen.item 
          :image=screen.image 
          :modal="`${screen.modal}`"
          :text=screen.permission 
          :altTxt=screen.tooltip 
          :title=screen.tooltip>
        </DropDownItemModal>
      </template>
      <!-- <b-dropdown-item
        v-if="user.role == 'GDI'"
       :to="`/adherenceindicatorsgdi`"
       :title="`Visualizar Aderência dos Indicadores`">
        <img class="dropItem"
          src="@/assets/producao.png"
        />
        Aderência dos Indicadores
      </b-dropdown-item> -->
      <b-dropdown-item
       v-if="user.role == 'PGDI'"
       :to="`/adherenceindicators/${user.UnitId}`"
       :title="`Visualizar Aderência dos Indicadores`">
        <img class="dropItem"
          src="@/assets/producao.png"
        />
        Aderência dos Indicadores
      </b-dropdown-item>
    </b-nav-item-dropdown>
  </b-nav>
</template>

<script>
import { mapState } from "vuex";
import DropDownItem from "./DropDownItem.vue"
import DropDownItemModal from "./DropDownItemModal.vue"

export default {
  name: "MonitoramentoDropdown",
  components: { DropDownItem, DropDownItemModal },
  computed: mapState(["user"]),
  data() {
    return {
      screenList: [],
      image: "Monitoramento.png"
    }
  },
  methods:{
    LoadScreen(){
      let screens = new Array
      for (let key in this.user.Permissions){
        if(key.match(/\bmonitoramento\d+\b/) && this.user.Permissions[key].allowed)
        {
          let obj = {};
          obj = this.user.Permissions[key]
          obj.screen = key
          obj.route = `/monitoring/${obj.parameter}`
          screens.push(obj)
        }
      }
        this.screenList = screens.sort((a, b) => a.id > b.id ? 1 : a.id < b.id ? -1 : 0 )
    }
  },
  created() {
    this.LoadScreen()
  }
};
</script>

<style scoped>
.txt {
  color: white;
  padding: 10px 20px;
}

img.Item {
  max-height: 37px;
  max-width: 37px;
  border-radius: 5px;
  margin: auto;
}
img.dropItem {
  max-height: 25px;
  max-width: 25px;
  border-radius: 5px;
  margin-right: 10px;
}

.ilink {
  margin-right: 10px;
}

</style>

<style>
  .dropdown-menu {
    height: auto;
    max-height: 350px;
    overflow-y: auto;
  }
</style>